module.exports = __webpack_public_path__ + "img/PDIL_preview.png";